import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';

export function useOrder() {
  const showToaster = useShowToaster();

  const fetchOrderById = async (id, setOrder) => {
    if (!id) return;
    try {
      const res = await instance.get(`/balance/balance-history/${id}`);
      setOrder(res?.data?.payment);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchOrderByIdPublic = async (id, setOrder) => {
    if (!id) return;
    try {
      const res = await instance.get(`/balance/refill/${id}`);
      setOrder(res?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const cancelOrder = async (id) => {
    try {
      const res = await instance.post(`/balance/refill/cancel/${id}`);
      showToaster('success', res?.data?.message);
      return true;
    } catch (err) {
      showToaster('error', err?.response?.data?.message);
    }
  };

  return { fetchOrderById, fetchOrderByIdPublic, cancelOrder };
}
